module.exports = __webpack_public_path__ + "indicators.9043408ff7b1b11a8e50552ff64c12cd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/selected/indicators.svg
// module id = 328
// module chunks = 0